import type { AircraftType } from '../game/types';

export const STARTER_MARKET_WEEKS = 28;
export const STARTER_MARKET_LOCK_REPUTATION = 100;

export const AIRCRAFT_TYPES: AircraftType[] = [
  {
    id: 'ATR72', name: 'ATR 72-600', family: '区域涡桨', rangeKm: 1528,
    cabins: { economy: 72, business: 0, first: 0 },
    maxEconomySeats: 82, speedKmh: 510,
    price: 25_500_000, weeklyHours: 66, turnaroundHours: 0.72, fuelCostPerHour: 1_480,
    weeklyFixedCost: 22_000, cycleCost: 1_650, idealStageKm: 520, perPassengerCost: 8, runwayClass: 1, minReputation: 0, accent: '#a8a29e',
    maxCycles: 12_000, maxFlightHours: 35_000,
  },
  {
    id: 'ARJ21', name: 'ARJ21-700', family: '区域喷气', rangeKm: 3700,
    cabins: { economy: 90, business: 0, first: 0 },
    maxEconomySeats: 104, speedKmh: 780,
    price: 38_000_000, weeklyHours: 70, turnaroundHours: 0.75, fuelCostPerHour: 2_200,
    weeklyFixedCost: 35_000, cycleCost: 2_800, idealStageKm: 900, perPassengerCost: 8, runwayClass: 2, minReputation: 45, accent: '#ef4444',
    maxCycles: 22_000, maxFlightHours: 30_000,
  },
  {
    id: 'E190E2', name: 'E190-E2', family: '区域喷气', rangeKm: 5000,
    cabins: { economy: 108, business: 6, first: 0 },
    maxEconomySeats: 138, speedKmh: 820,
    price: 44_000_000, weeklyHours: 70, turnaroundHours: 0.78, fuelCostPerHour: 2_650,
    weeklyFixedCost: 46_000, cycleCost: 3_900, idealStageKm: 1_000, perPassengerCost: 10, runwayClass: 2, minReputation: 48, accent: '#65a30d',
    maxCycles: 25_000, maxFlightHours: 40_000,
  },
  {
    id: 'A223', name: 'A220-300', family: '中型窄体', rangeKm: 6300,
    cabins: { economy: 135, business: 10, first: 0 },
    maxEconomySeats: 178, speedKmh: 850,
    price: 52_000_000, weeklyHours: 78, turnaroundHours: 0.72, fuelCostPerHour: 2_380,
    weeklyFixedCost: 40_000, cycleCost: 3_000, idealStageKm: 1_400, perPassengerCost: 7, runwayClass: 2, minReputation: 50, accent: '#3b82f6',
    maxCycles: 25_000, maxFlightHours: 45_000,
  },
  {
    id: 'C919', name: 'C919', family: '中型窄体', rangeKm: 5555,
    cabins: { economy: 156, business: 8, first: 0 },
    maxEconomySeats: 198, speedKmh: 834,
    price: 50_000_000, weeklyHours: 76, turnaroundHours: 0.72, fuelCostPerHour: 2_500,
    weeklyFixedCost: 41_000, cycleCost: 3_200, idealStageKm: 1_100, perPassengerCost: 7, runwayClass: 2, minReputation: 50, accent: '#dc2626',
    maxCycles: 20_000, maxFlightHours: 35_000,
  },
  {
    id: 'B38M', name: '737 MAX 8', family: '主力窄体', rangeKm: 6480,
    cabins: { economy: 162, business: 16, first: 0 },
    maxEconomySeats: 223, speedKmh: 830,
    price: 53_000_000, weeklyHours: 78, turnaroundHours: 0.70, fuelCostPerHour: 2_580,
    weeklyFixedCost: 43_000, cycleCost: 3_400, idealStageKm: 1_200, perPassengerCost: 7, runwayClass: 2, minReputation: 52, accent: '#f59e0b',
    maxCycles: 25_000, maxFlightHours: 40_000,
  },
  {
    id: 'A320N', name: 'A320neo', family: '主力窄体', rangeKm: 6300,
    cabins: { economy: 168, business: 18, first: 0 },
    maxEconomySeats: 235, speedKmh: 840,
    price: 55_000_000, weeklyHours: 78, turnaroundHours: 0.70, fuelCostPerHour: 2_620,
    weeklyFixedCost: 44_000, cycleCost: 3_450, idealStageKm: 1_100, perPassengerCost: 7, runwayClass: 2, minReputation: 52, accent: '#06b6d4',
    maxCycles: 25_000, maxFlightHours: 45_000,
  },
  {
    id: 'A321XLR', name: 'A321XLR', family: '远程窄体', rangeKm: 8700,
    cabins: { economy: 180, business: 20, first: 0 },
    maxEconomySeats: 253, speedKmh: 840,
    price: 82_000_000, weeklyHours: 78, turnaroundHours: 0.9, fuelCostPerHour: 3_450,
    weeklyFixedCost: 61_000, cycleCost: 4_800, idealStageKm: 2_400, perPassengerCost: 10, runwayClass: 3, minReputation: 60, accent: '#8b5cf6',
    maxCycles: 22_000, maxFlightHours: 40_000,
  },
  {
    id: 'A333', name: 'A330-300', family: '大型宽体', rangeKm: 11_300,
    cabins: { economy: 260, business: 36, first: 4 },
    maxEconomySeats: 396, speedKmh: 870,
    price: 175_000_000, weeklyHours: 82, turnaroundHours: 1.35, fuelCostPerHour: 6_900,
    weeklyFixedCost: 118_000, cycleCost: 9_000, idealStageKm: 5_000, perPassengerCost: 15, runwayClass: 3, minReputation: 66, accent: '#0ea5e9',
    maxCycles: 18_000, maxFlightHours: 55_000,
  },
  {
    id: 'B789', name: '787-9', family: '高效宽体', rangeKm: 14_010,
    cabins: { economy: 252, business: 34, first: 4 },
    maxEconomySeats: 382, speedKmh: 903,
    price: 190_000_000, weeklyHours: 82, turnaroundHours: 1.42, fuelCostPerHour: 6_700,
    weeklyFixedCost: 126_000, cycleCost: 9_200, idealStageKm: 5_200, perPassengerCost: 15, runwayClass: 3, minReputation: 68, accent: '#f97316',
    maxCycles: 18_000, maxFlightHours: 65_000,
  },
  {
    id: 'B77W', name: '777-300ER', family: '大型宽体', rangeKm: 13_650,
    cabins: { economy: 318, business: 44, first: 3 },
    maxEconomySeats: 477, speedKmh: 905,
    price: 240_000_000, weeklyHours: 84, turnaroundHours: 1.50, fuelCostPerHour: 8_500,
    weeklyFixedCost: 160_000, cycleCost: 13_500, idealStageKm: 6_000, perPassengerCost: 16, runwayClass: 4, minReputation: 74, accent: '#eab308',
    maxCycles: 16_000, maxFlightHours: 60_000,
  },
  {
    id: 'A35K', name: 'A350-1000', family: '大型宽体', rangeKm: 16_100,
    cabins: { economy: 322, business: 44, first: 3 },
    maxEconomySeats: 482, speedKmh: 910,
    price: 285_000_000, weeklyHours: 84, turnaroundHours: 1.62, fuelCostPerHour: 8_300,
    weeklyFixedCost: 172_000, cycleCost: 12_500, idealStageKm: 6_200, perPassengerCost: 17, runwayClass: 4, minReputation: 76, accent: '#64748b',
    maxCycles: 16_000, maxFlightHours: 70_000,
  },
];

export function aircraftType(typeId: string): AircraftType {
  const result = AIRCRAFT_TYPES.find((item) => item.id === typeId);
  if (!result) throw new Error(`未知机型：${typeId}`);
  return result;
}

export function aircraftMarketReputation(typeId: string, week: number): number {
  const index = AIRCRAFT_TYPES.findIndex((item) => item.id === typeId);
  const type = AIRCRAFT_TYPES[index];
  if (!type) throw new Error(`未知机型：${typeId}`);
  if (week <= STARTER_MARKET_WEEKS && index > 1) return Math.max(type.minReputation, STARTER_MARKET_LOCK_REPUTATION);
  return type.minReputation;
}
